import { computed, Injectable, signal } from '@angular/core';
import { GameInterfaceState } from 'src/app/features/game/controllers/listeners/ux-game-listener';

@Injectable({
  providedIn: 'root',
})
export class GameScoreService {
  private gameNameSignal = signal<string | undefined>(undefined);
  private gameInterfaceStateSignal = signal<GameInterfaceState>(GameInterfaceState.GameLoading);
  private scoreSignal = signal<number>(0);
  private countdownSignal = signal<number | undefined>(undefined);
  private tournamentCountdownSignal = signal<number | undefined>(undefined);
  private formattedRewardSignal = signal<string | undefined>(undefined);
  private opponentSignal = signal<string | undefined>(undefined);
  private opponentIdSignal = signal<string | undefined | null>(undefined);
  private bountyAmountSignal = signal<number | undefined>(undefined);

  get gameName() {
    return this.gameNameSignal.asReadonly();
  }

  get gameInterfaceState() {
    return this.gameInterfaceStateSignal.asReadonly();
  }

  get score() {
    return this.scoreSignal.asReadonly();
  }

  get countdown() {
    return this.countdownSignal.asReadonly();
  }

  get formattedReward() {
    return this.formattedRewardSignal.asReadonly();
  }

  get opponent() {
    return this.opponentSignal.asReadonly();
  }

  get opponentId() {
    return computed(() => {
      const value = this.opponentIdSignal();
      return value ?? undefined;
    });
  }

  get tournamentCountdown() {
    return this.tournamentCountdownSignal.asReadonly();
  }

  get bountyAmount() {
    return this.bountyAmountSignal.asReadonly();
  }

  setGameName(gameName: string) {
    this.gameNameSignal.set(gameName);
  }

  setGameInterfaceState(gameInterfaceState: GameInterfaceState) {
    this.gameInterfaceStateSignal.set(gameInterfaceState);
  }

  setScore(score: number | undefined) {
    this.scoreSignal.set(score ?? 0);
  }

  setCountdown(countdown: number) {
    this.countdownSignal.set(countdown);
  }

  setTournamentCountdown(countdown: number) {
    this.tournamentCountdownSignal.set(countdown);
  }

  setFormattedReward(reward: string | undefined) {
    this.formattedRewardSignal.set(reward);
  }

  setOpponent(opponent: string | undefined) {
    this.opponentSignal.set(opponent);
  }

  setOpponentId(opponentId: string | undefined | null) {
    this.opponentIdSignal.set(opponentId);
  }

  setBountyAmount(bountyAmount: number | undefined) {
    this.bountyAmountSignal.set(bountyAmount);
  }

  clear() {
    this.gameNameSignal.set(undefined);
    this.gameInterfaceStateSignal.set(GameInterfaceState.GameLoading);
    this.scoreSignal.set(0);
    this.countdownSignal.set(undefined);
    this.tournamentCountdownSignal.set(undefined);
    this.formattedRewardSignal.set(undefined);
    this.opponentSignal.set(undefined);
    this.opponentIdSignal.set(undefined);
    this.bountyAmountSignal.set(undefined);
  }
}
